import * as yup from 'yup'

const complaintConfigurationSchema = yup.object().shape({
  recurringEmail: yup.boolean().required(),
  recurringEmailDays: yup.string().when('recurringEmail', {
    is: true,
    then: yup
      .string()
      .required()
      .matches(/^[1-5]+$/, 'Selecione um número de 1 a 5'),
  }),
  identification: yup.boolean().required(),
})

export default complaintConfigurationSchema
